import React from 'react';

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Stack, StackProps, Typography } from '@mui/material';

export const EmptyTreatmentPrescription: React.FC<StackProps> = (props) => {
  return (
    <Stack
      spacing={1}
      flex={1}
      justifyContent="center"
      alignItems="center"
      border="1px solid #8E8E8E"
      borderRadius="4px"
      py={2}
      {...props}
    >
      <InfoOutlinedIcon />
      <Typography fontWeight={400} color="#4B4B4B">
        Sem registros. Para adicionar um medicamento ou exame só clicar nos
        botões abaixo.
      </Typography>
    </Stack>
  );
};
